module.exports = __webpack_public_path__ + "img/logo.7aaf8ad1.png";